import { render, staticRenderFns } from "./TableRecibosAdmin.vue?vue&type=template&id=26602229&"
import script from "./TableRecibosAdmin.vue?vue&type=script&lang=js&"
export * from "./TableRecibosAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports